"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SDObject_SDid, _SDObject_SDversion;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDObject = void 0;
const THREE = __importStar(require("three"));
const three_1 = require("three");
class SDObject extends three_1.Object3D {
    constructor(SDid, SDversion) {
        super();
        // #region Constructors (1)
        _SDObject_SDid.set(this, void 0);
        _SDObject_SDversion.set(this, void 0);
        __classPrivateFieldSet(this, _SDObject_SDid, SDid, "f");
        __classPrivateFieldSet(this, _SDObject_SDversion, SDversion, "f");
    }
    applyTransformation(transformation) {
        this.matrix.identity();
        this.matrixWorld.identity();
        this.position.set(0, 0, 0);
        this.scale.set(1, 1, 1);
        this.quaternion.set(0, 0, 0, 1);
        this.applyMatrix4(new THREE.Matrix4().fromArray(transformation));
    }
    // #endregion Constructors (1)
    // #region Public Accessors (4)
    get SDid() {
        return __classPrivateFieldGet(this, _SDObject_SDid, "f");
    }
    set SDid(value) {
        __classPrivateFieldSet(this, _SDObject_SDid, value, "f");
    }
    get SDversion() {
        return __classPrivateFieldGet(this, _SDObject_SDversion, "f");
    }
    set SDversion(value) {
        __classPrivateFieldSet(this, _SDObject_SDversion, value, "f");
    }
    cloneObject() {
        const clone = this.clone();
        clone.SDid = this.SDid;
        clone.SDversion = this.SDversion;
        return clone;
    }
}
exports.SDObject = SDObject;
_SDObject_SDid = new WeakMap(), _SDObject_SDversion = new WeakMap();
//# sourceMappingURL=SDObject.js.map